import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiInstance } from '../../Apis/Axios';
import { COMPANY_SERVICE } from '../EndPoints';

export const companyDataToUpdate = createAsyncThunk('updateCompany/companyDataToUpdate', async (companyId) => {
    const result = await apiInstance
        .get(COMPANY_SERVICE.companyDataToUpdate)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = result;

    return { data, status };
});

export const updateCompany = createAsyncThunk('updateCompany/updateCompany', async (params) => {
    const result = await apiInstance
        .put(COMPANY_SERVICE.updateCompany, params)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = result;

    return { data, status };
});